export class InfoGeneral {
    constructor({ tipoFrmEmpresa } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
                isDate: true,
                body: (rowData) => {
                    if (!rowData.fecha) return null;
                    return new Date(rowData.fecha + 'T00:00:00').toLocaleDateString(); // Media noche hora local
                }
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            canton: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4
            },
            tipo_persona: {
                value: null,
                header: 'Tipo de proveedor:',
                required: 'Tipo de persona es requerido'
            },
            tipo_informacion: {
                value: null, header: 'Tipo de declaración:',
                required: 'Tipo de declaración es requerido'
            },
            tipo_identificacion: {
                value: null, required: 'Tipo de identificación es requerido',
                header: 'Tipo de identificación',
                headerPorTipo: {
                    FRM_TOYOTA: 'Tipo de documento:',
                    FRM_DIFARE: 'Tipo de documento:',
                }
            },
            empresa_registro: {
                header: 'Empresa'
            },
            identificacion: {
                value: '',
                header: 'Identificación',
                headerPorTipo: {
                    FRM_TOYOTA: 'No. RUC / Identificación tributaria:',
                    FRM_DIFARE: 'No. RUC / Identificación tributaria:',
                },
                required: 'Identificación es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4
            },
            nombre_completo: {
                value: '', header: 'Nombres / Razón social'
            },
            compania: {
                value: '', header: 'Compañía que contrata:',
                required: 'Compañía contratada es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4,
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            proyecto: {
                value: false,
                header: 'Agrupa para proyecto empresarial:',
                required: 'Agrupa para proyecto empresarial es requerido',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            nombres: {
                value: '',
                header: 'Nombres',
                required: 'Nombres es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            apellidos: {
                value: '',
                header: 'Apellidos',
                required: 'Apellidos es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            razon_social: {
                value: '', header: 'Razón Social',
                headerPorTipo: {
                    FRM_TOYOTA: 'Razón Social:',
                    FRM_DIFARE: 'Razón Social / Nombres y Apellidos Completos:',
                },
                required: 'Razón Social es requerido',
                maxLength: 'Máximo 400 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 400,
                min: 4
            },
            actividad: {
                value: null,
                header: 'Actividad Económica:',
                required: 'Actividad Económica es requerido.'
            },
            fecha_constitucion: {
                value: null,
                header: 'Fecha de constitución (según Escritura):',
                required: 'Fecha de constitución es requerido',
                table: false,
                tablePorTipo: {
                    FRM_DIFARE: true,
                }
            },
            fecha_inicio: {
                value: null,
                header: 'Fecha de inicio de actividad económica:',
                headerPorTipo: {
                    FRM_DIFARE: 'Fecha de inicio de actividades (según SRI):',
                },
                required: 'Fecha de incio de actividad económica es requerido'
            },
            web: {
                value: '',
                header: 'Página web o dirección electrónica de la empresa:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Página web:',
                },
                required: 'Página web o dirección electrónica de la empresa es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            direccion_oficina: {
                value: '',
                header: 'Dirección oficina / negocio:',
                required: 'Dirección principal es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4
            },
            direccion_ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            direccion_canton: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4
            },
            direccion_pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            direccion_provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            codigo_postal: {
                value: '',
                header: 'Apartado postal',
                headerPorTipo: {
                    FRM_TOYOTA: 'Apartado postal (en el caso de ser extranjero)',
                    FRM_DIFARE: 'Apartado postal (en el caso de ser extranjero)',
                },
                required: 'Apartado postal es requerido',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
            },
            telefono: {
                value: '',
                header: 'Teléfono',
                headerPorTipo: {
                    FRM_DIFARE: 'Teléfono oficina:',
                    FRM_TOYOTA: 'Teléfono oficina:',
                },
                required: 'Teléfono es requerido',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4,
            },
            grupo: {
                value: null,
                header: 'Grupo:',
            },
            empresas_seleccionadas: {
                value: null,
                header: 'Empresas:',
                required: 'Seleccione por lo menos una empresa'
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
}
